export const SuperAdminMenuList = [
  //Dashboard
  {
    title: "Main Menu",
    classsChange: "menu-title",
    extraclass: "first",
  },
  //Dashboard
  {
    title: "Dashboard",
    to: "dashboard",
    iconStyle: <i className="la la-home" />,
  },

  //Tenants
  {
    title: "Academies",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-building" />,
    content: [
      {
        title: "All Academies",
        to: "all-academies",
      },
      {
        title: "Add academy",
        to: "add-academy",
      },
    ],
  },

  // Users
  {
    title: "Users",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-users" />,
    content: [
      {
        title: "All Users",
        to: "all-users",
      },
      {
        title: "Add User",
        to: "add-user",
      },
    ],
  },

  {
    title: "Academies Approval",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-check-circle" />,
    content: [
      {
        title: "Pending Academies",
        to: "pending-academies",
      },
    ],
  },

  {
    title: "Settings",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-cog" />,
    content: [
      {
        title: "Payment Gateway",
        to: "payment-gateway",
      },
    ],
  },

  {
    title: "Reports",
    classsChange: "mm-collapse",
    iconStyle: <i className="la la-file-text" />,
    content: [
      {
        title: "Academies Reports",
        to: "academices-report",
      },
      {
        title: "Email Reports",
        to: "email-report",
      },
      {
        title: "Users Reports",
        to: "users-report",
      },
      {
        title: "Payment History Reports",
        to: "payment-history-report",
      },
      {
        title: "Registration Academics Reports",
        to: "registration-academics-report",
      },
    ],
  },
];
